/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

export const selectGlobal = (state) => state.get('global');

export const selectSpinner = createSelector(selectGlobal, (globalState) => globalState.get('spinner'));

export const selectErrors = createSelector(selectGlobal, (globalState) => globalState.get('errors').toJS());
